import FileAttachments from '../FileAttachments';
import { focusTheme } from '../../utils/focusTheme';

function ActivityAttachments({ attachments = [], title = 'فایل‌های پیوست' }) {
  if (!attachments?.length) {
    return null;
  }

  return (
    <div
      className="flex flex-col gap-2 p-2 rounded-[8px]"
      style={{ background: focusTheme.sectionBg }}
    >
      <FileAttachments
        attachments={attachments}
        title={title}
        variant="embedded"
      />
    </div>
  );
}

export default ActivityAttachments;
